export const fieldIcons = {
  answers: 'far fa-comment-dots',
  company: 'far fa-building',
  created: 'far fa-calendar-alt',
  customAttribute: 'fas fa-exchange-alt',
  customer: 'far fa-user',
  email: 'far fa-envelope',
  emailEvent: 'far fa-paper-plane',
  externalId: 'far fa-square-user',
  feedbackId: 'far fa-hashtag',
  integrationSource: 'fas fa-exchange-alt',
  ipAddress: 'far fa-street-view',
  language: 'far fa-globe',
  metric: 'far fa-chart-line',
  question: 'far fa-question',
  questions: 'far fa-square-question',
  responses: 'far fa-paper-plane',
  sentiment: 'far fa-face-smile',
  status: 'far fa-circle-notch',
  survey: 'far fa-filter',
  surveyType: 'fas fa-parachute-box',
  tag: 'far fa-tag',
  teamMember: 'far fa-user-headset',
  ticket: 'far fa-ticket',
  topic: 'far fa-chart-network',
} as const

export type FieldIcon = typeof fieldIcons[keyof typeof fieldIcons]

export const collaboratorRoleIcon = 'far fa-user-tag'

export const fieldIconByColumnLabel: Record<string, FieldIcon> = {
  Collaborator: fieldIcons.teamMember,
  Company: fieldIcons.company,
  'Company Name': fieldIcons.company,
  'Customer Company': fieldIcons.company,
  'Customer Email': fieldIcons.customer,
  'Customer External ID': fieldIcons.externalId,
  'Customer ID': fieldIcons.customer,
  'Customer Name': fieldIcons.customer,
  'Customer tag': fieldIcons.tag,
  Created: fieldIcons.created,
  Date: fieldIcons.created,
  'Email Event': fieldIcons.emailEvent,
  'Feedback ID': fieldIcons.feedbackId,
  'IP Address': fieldIcons.ipAddress,
  Language: fieldIcons.language,
  Metric: fieldIcons.metric,
  question: fieldIcons.question,
  'Response ID': fieldIcons.feedbackId,
  Sentiment: fieldIcons.sentiment,
  Source: fieldIcons.survey,
  Status: fieldIcons.status,
  Survey: fieldIcons.survey,
  'Survey ID': fieldIcons.survey,
  'Survey Name': fieldIcons.survey,
  'Survey Type': fieldIcons.surveyType,
  Tag: fieldIcons.tag,
  Tags: fieldIcons.tag,
  'Team Member Email': fieldIcons.teamMember,
  'Team Member ID': fieldIcons.externalId,
  'Team Member Name': fieldIcons.teamMember,
  'Ticket ID': fieldIcons.ticket,
  'Ticket Subject': fieldIcons.ticket,
  Topic: fieldIcons.topic,
  'Topic group': fieldIcons.topic,
  'Topic pair.sentiment': fieldIcons.topic,
  'Topic sentiment': fieldIcons.topic,
  Topics: fieldIcons.topic,
}



// WEBPACK FOOTER //
// ./src/shared/constants/fieldIcons.ts